import { CRYPTO_IV_LENGTH } from '#block-store/types';
export const deserializeAesValue = (serialized) => {
    const iv = serialized.subarray(0, CRYPTO_IV_LENGTH);
    const value = serialized.subarray(CRYPTO_IV_LENGTH);
    return { value, iv };
};
